import { Sk } from '@quizzach/styles';

/** Shimmer blocks shaped like the premade sale-ticket card. */
export const PremadeLoadingSkeleton = ({
	numberOfQuizzes,
}: {
	numberOfQuizzes?: number;
}) => {
	return Array.from({ length: numberOfQuizzes || 8 }).map((_, index) => (
		<Sk key={index} className='sale-sk' aria-hidden='true' />
	));
};
